export default "__VITE_ASSET__BdVbVRQi__"